import React, { useEffect } from "react";
import dayjs from "dayjs";
import styles from "./PatientDashboard.module.scss";
import { useQueryParam } from "hooks/useQueryParam";
import { jwtDecode } from "jwt-decode";
import { useMsal } from "@azure/msal-react";
import { useCurrentPatient } from "./hooks/useCurrentPatient";
import { useIdleTimer } from "react-idle-timer";
import { ErrorToast } from "./ErrorToast";
import { Modal } from "components/Modal";
import { IdleModalContent } from "features/routing/components/IdleModalContent/IdleModalContent";
import { MyAccountCAIM } from "./MyAccountCAIM";
import { Layout } from "features/layout/Layout";
import { Navbar } from "components/Navbar";

const getGreeting = () => {
  const hour = dayjs().hour();

  if (hour < 12) {
    return "Morning";
  } else if (hour < 17) {
    return "Afternoon";
  } else {
    return "Evening";
  }
};

export const PatientDashboardCAIM: React.FC = () => {
  const { handleLogoutRedirect } = useCurrentPatient();
  const [caimToken, setCaim] = useQueryParam("idToken", null);
  const { instance } = useMsal();


  // Idle/session timer logic (5 min idle, 1 min warning)
  const IDLE_SESSION_TIMER = 15 * 60 * 1000; // 15 min
  const LOGOUT_TIMER = 15 * 60 * 1000; // 15 min
  const [isIdleModalOpen, setIdleModalOpen] = React.useState(false);
  const [logoutTimerId, setLogoutTimer] = React.useState<number>();

  const forceLogout = () => handleLogoutRedirect();
  const showIdleModal = () => {
    setIdleModalOpen(true);
    setLogoutTimer(window.setTimeout(forceLogout, LOGOUT_TIMER));
  };
  const cancelLogout = () => {
    setIdleModalOpen(false);
    clearTimeout(logoutTimerId);
  };

  useIdleTimer({
    timeout: IDLE_SESSION_TIMER,
    onIdle: showIdleModal,
  });
  useIdleTimer({
    timeout: IDLE_SESSION_TIMER + LOGOUT_TIMER,
    onIdle: forceLogout,
  });

  useEffect(() => {
    if (!caimToken || (instance && !instance.getActiveAccount())) {
      handleLogoutRedirect();
    }
  }, [caimToken, instance, handleLogoutRedirect]);

  if (!caimToken) {
    return null;
  }
  const jwt_user = jwtDecode(caimToken);
  return (
    <Layout
      showBanner={true}
      scheduleBanner={true}
      bannerTypes={["global", "patient_portal", "maintenance"]}
      navbar={
        <>
          <Navbar
            className={styles.myAccount}
          >
            <MyAccountCAIM />
          </Navbar>
        </>
      }
    >
      <ErrorToast />
      <div className={styles.container}>
        <div className={styles.patientGreeting}>
          Good {getGreeting()},
          <h1 id="chk-patientName" className={styles.patientName}>
            {jwt_user.name}
          </h1>
        </div>
        <div className={styles.unfortunately}>
          Unfortunately we could not find an existing MyEyeDr. patient that matched the information you provided when registering your account. If you believe this is in error, please <a href={"https://locations.myeyedr.com/search"}>contact your local office</a>.
        </div>       
      </div>
      <Modal
        isOpen={isIdleModalOpen}
        onRequestClose={cancelLogout}
        overlayClassName={styles.overlay}
      >
        <IdleModalContent timer={LOGOUT_TIMER} dismiss={cancelLogout} />
      </Modal>
    </Layout>
  );
};
